import ReactMarkdown from 'react-markdown';

const mono = `'DM Mono', ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace`;

/**
 * Renders assistant chat content as Markdown (lists, short paragraphs, fenced code).
 */
export function ChatMarkdown({ children, className = '' }) {
  return (
    <div className={`chat-md ${className}`}>
      <ReactMarkdown
        components={{
          p: (props) => <p style={{ margin: '0 0 0.65em 0' }} {...props} />,
          ul: (props) => (
            <ul style={{ margin: '0 0 0.65em 0', paddingLeft: '1.2em' }} {...props} />
          ),
          ol: (props) => (
            <ol style={{ margin: '0 0 0.65em 0', paddingLeft: '1.2em' }} {...props} />
          ),
          li: (props) => <li style={{ marginBottom: '0.2em' }} {...props} />,
          strong: (props) => <strong style={{ color: '#E8ECF4' }} {...props} />,
          hr: () => (
            <hr
              style={{
                border: 'none',
                borderTop: '1px solid rgba(255,255,255,0.12)',
                margin: '0.75em 0',
              }}
            />
          ),
          pre: (props) => (
            <pre
              style={{
                margin: '0.65em 0',
                padding: '10px 12px',
                borderRadius: '8px',
                background: 'rgba(0,0,0,0.5)',
                border: '1px solid rgba(255,255,255,0.1)',
                overflow: 'auto',
                maxWidth: '100%',
              }}
              {...props}
            />
          ),
          code({ className, children, ...rest }) {
            const text = String(children);
            const isBlock =
              (className && /^language-/.test(className)) || text.includes('\n');
            if (!isBlock) {
              return (
                <code
                  style={{
                    fontFamily: mono,
                    fontSize: '12px',
                    background: 'rgba(0,212,255,0.14)',
                    padding: '1px 5px',
                    borderRadius: '4px',
                    wordBreak: 'break-word',
                  }}
                  {...rest}
                >
                  {children}
                </code>
              );
            }
            return (
              <code
                className={className}
                style={{
                  display: 'block',
                  fontFamily: mono,
                  fontSize: '12px',
                  lineHeight: 1.45,
                  whiteSpace: 'pre',
                  overflowX: 'auto',
                  background: 'transparent',
                  padding: 0,
                  margin: 0,
                  wordBreak: 'normal',
                }}
                {...rest}
              >
                {children}
              </code>
            );
          },
        }}
      >
        {children}
      </ReactMarkdown>
    </div>
  );
}
